(function () {
  'use strict';

  var CONTAINER_ID = 'sp-auto-recommendations';
  var REC_TITLE    = 'You might also like';

  // Persistent state across arrow clicks; resets on each fetchAndRender call
  var state = { products: [], index: 0, cartIds: [] };

  // ── Utilities ─────────────────────────────────────────────────────────────

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function imgSize(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^./?]+)(\?.*)?$/, '_' + size + '$1$2');
  }

  function getCartIds(container) {
    var raw = container && container.dataset.cartProductIds;
    return (raw || '').split(',').map(Number).filter(Boolean);
  }

  // ── Arrow button styles (injected once) ───────────────────────────────────

  function injectStyles() {
    if (document.getElementById('sp-rec-styles')) return;
    var s = document.createElement('style');
    s.id = 'sp-rec-styles';
    s.textContent =
      '.sp-rec-arrows{display:flex;gap:5px;align-items:center}' +
      '.sp-rec-arrow{width:26px;height:26px;border-radius:50%;border:1px solid currentColor;' +
        'opacity:0.45;background:transparent;cursor:pointer;padding:0;color:inherit;' +
        'display:flex;align-items:center;justify-content:center;transition:opacity .15s}' +
      '.sp-rec-arrow:hover{opacity:1}' +
      '.sp-rec-arrow svg{display:block}';
    document.head.appendChild(s);
  }

  var CHEV_L = '<svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1L1.5 5.5L6 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_R = '<svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5.5 5.5L1 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // ── Card HTML (matches Prestige horizontal-product-card snippet) ──────────

  function buildCard(product, idx) {
    var variant = product.variants && product.variants[0];
    if (!variant) return '';

    var isSingle = product.variants.length === 1;
    var modalId  = 'sp-rec-qb-' + product.id + '-' + idx;
    var imageUrl = imgSize(product.featured_image, '200x');
    var url      = '/products/' + esc(product.handle);

    var priceHtml;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceHtml =
        '<span class="price price--on-sale">' + money(variant.price) + '</span>' +
        '<s class="price price--compare text-subdued">' + money(variant.compare_at_price) + '</s>';
    } else {
      priceHtml = '<span class="price">' + money(variant.price) + '</span>';
    }

    var qbHtml = '';
    if (product.available) {
      if (isSingle) {
        qbHtml =
          '<button type="button" class="@narrow:horizontal-product-card__button link sp-rec-add"' +
          ' data-variant-id="' + variant.id + '">Add to cart</button>' +
          '<button type="button" class="@large:horizontal-product-card__button button button--outline button--subdued sp-rec-add"' +
          ' data-variant-id="' + variant.id + '">Add to cart</button>';
      } else {
        qbHtml =
          '<quick-buy-modal id="' + modalId + '"' +
          ' handle="' + esc(product.handle) + '?variant=' + variant.id + '"' +
          ' class="quick-buy-modal modal modal--lg color-scheme color-scheme--dialog">LOADING</quick-buy-modal>' +
          '<button type="button" aria-controls="' + modalId + '"' +
          ' class="@narrow:horizontal-product-card__button link">Add to cart</button>' +
          '<button type="button" aria-controls="' + modalId + '"' +
          ' class="@large:horizontal-product-card__button button button--outline button--subdued">Add to cart</button>';
      }
    }

    return [
      '<div class="horizontal-product-card">',
        imageUrl
          ? '<a href="' + url + '" class="horizontal-product-card__figure" data-instant>' +
            '<img src="' + esc(imageUrl) + '" alt="' + esc(product.title) + '"' +
            ' width="100" height="100" loading="lazy" class="horizontal-product-card__image">' +
            '</a>'
          : '',
        '<div class="horizontal-product-card__info">',
          '<div class="v-stack gap-1 justify-items-start">',
            '<a href="' + url + '" class="product-title h6" data-instant>' + esc(product.title) + '</a>',
            '<div class="price-list">' + priceHtml + '</div>',
          '</div>',
          qbHtml,
        '</div>',
      '</div>'
    ].join('');
  }

  // ── Render current slide ──────────────────────────────────────────────────

  function renderSlide(inner) {
    var products = state.products;
    var idx      = state.index;
    if (products.length === 0) { inner.innerHTML = ''; return; }

    var showNav  = products.length > 1;
    var cardHtml = buildCard(products[idx], idx);

    inner.innerHTML = [
      '<div class="cart-drawer__complementary-products complementary-products">',
        '<div class="complementary-products__header complementary-products__header--align-start">',
          '<p class="h6">' + esc(REC_TITLE) + '</p>',
          showNav
            ? '<div class="sp-rec-arrows">' +
              '<button type="button" class="sp-rec-arrow sp-rec-prev" aria-label="Previous">'
                + CHEV_L + '</button>' +
              '<button type="button" class="sp-rec-arrow sp-rec-next" aria-label="Next">'
                + CHEV_R + '</button>' +
              '</div>'
            : '',
        '</div>',
        '<div class="complementary-products__product-list">',
          cardHtml,
        '</div>',
      '</div>'
    ].join('');

    // Wire up add-to-cart
    inner.querySelectorAll('.sp-rec-add').forEach(function (btn) {
      btn.addEventListener('click', function () { handleAdd(btn.dataset.variantId, btn); });
    });

    // Wire up arrows
    if (showNav) {
      inner.querySelector('.sp-rec-prev').addEventListener('click', function () {
        state.index = (state.index - 1 + state.products.length) % state.products.length;
        renderSlide(inner);
      });
      inner.querySelector('.sp-rec-next').addEventListener('click', function () {
        state.index = (state.index + 1) % state.products.length;
        renderSlide(inner);
      });
    }
  }

  // ── Add to cart + refresh cart drawer ─────────────────────────────────────

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newCD  = doc.querySelector('cart-drawer');
        var oldCD  = document.querySelector('cart-drawer');
        if (newCD && oldCD) {
          oldCD.replaceWith(newCD);
        } else {
          var el = document.querySelector('[class*="shopify-section--cart-drawer"]') ||
                   document.querySelector('.shopify-section--cart-drawer');
          if (el) el.innerHTML = html;
        }
      });
  }

  function handleAdd(variantId, btn) {
    var allBtns = btn.closest('.horizontal-product-card').querySelectorAll('.sp-rec-add');
    allBtns.forEach(function (b) { b.disabled = true; b.textContent = '…'; });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function () {
        allBtns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; });
      });
  }

  // ── Fetch recommendations & render ────────────────────────────────────────

  function fetchAndRender(container) {
    var cartIds = getCartIds(container);
    var inner   = container.querySelector('.sp-recs-inner');
    if (!inner) return;
    if (cartIds.length === 0) { inner.innerHTML = ''; return; }

    fetch('/recommendations/products.json?product_id=' + cartIds[0] + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || [])
          .filter(function (p) { return cartIds.indexOf(p.id) === -1 && p.available; })
          .slice(0, 4);

        if (products.length === 0) { inner.innerHTML = ''; return; }

        state.products = products;
        state.index    = 0;
        state.cartIds  = cartIds;

        injectStyles();
        renderSlide(inner);
      })
      .catch(function () {});
  }

  // ── Init & MutationObserver ────────────────────────────────────────────────

  function boot() {
    var c = document.getElementById(CONTAINER_ID);
    if (c && !c.dataset.recsReady) {
      c.dataset.recsReady = '1';
      fetchAndRender(c);
    }
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var c = node.id === CONTAINER_ID
          ? node
          : (node.querySelector ? node.querySelector('#' + CONTAINER_ID) : null);
        if (c && !c.dataset.recsReady) {
          c.dataset.recsReady = '1';
          fetchAndRender(c);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
